import { Component, Input } from '@angular/core';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { OrderModel } from 'models/generated/Entities.GormCrm.Order';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { SalesService } from 'services/sales.service';

@Component({
	selector: 'edit-order-installments',
	templateUrl: './edit-order-installments.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomSelectComponent, TranslatePipe]
})
export class EditOrderInstallmentsComponent {

	private _order?: OrderModel;
	@Input()
	set order(order: OrderModel | undefined) {
		this._order = order;

		const uniqueInstallments = order?.orderLines ? this.getUniqueValues(order?.orderLines, "numberOfInstallments") : undefined;
		const uniqueStartupInstallments = order?.orderLines ? this.getUniqueValues(order?.orderLines, "startupInstallments") : undefined;

		this.selectedInstallment = uniqueInstallments?.length === 1 ? uniqueInstallments[0] : uniqueInstallments?.length === 0 ? undefined : -1; // -1 = show blank
		this.selectedStartupInstallment = uniqueStartupInstallments?.length == 1 ? uniqueStartupInstallments[0] : uniqueStartupInstallments?.length == 0 ? undefined : -1;
	}
	get order() { return this._order }

	availableInstallments: SelectListItemModel[];
	selectedInstallment?: number;
	selectedStartupInstallment?: number;

	constructor(private navigationService: NavigationService, private salesService: SalesService) {
		this.availableInstallments = [...Array.from(Array(11).keys()).map(i => new SelectListItemModel(i + 1, (i + 1).toString()))];
	}

	private getUniqueValues<T extends { startupAmount?: number }>(items: T[], property: keyof T): (T[keyof T])[] {
		return [...new Set(
			items
				.filter(item => (item.startupAmount !== undefined && property == "startupInstallments") || property != "startupInstallments") 
				.map(item => item[property]) 
				.filter(value => value !== undefined)
		)] as (T[keyof T])[];
	}

	save() {
		if (!this.order?.id) return;

		this.selectedInstallment = this.selectedInstallment === -1 ? undefined : this.selectedInstallment;
		this.selectedStartupInstallment = this.selectedStartupInstallment === -1 ? undefined : this.selectedStartupInstallment;

		if (this.selectedInstallment == undefined && this.selectedStartupInstallment == undefined) {
			this.navigationService.closeView(this);
			return;
		}

		this.salesService.updateInstallments(this.order.id, this.selectedInstallment, this.selectedStartupInstallment)
			.then(() => this.navigationService.closeView(this));
	}
}
